module.exports = __webpack_public_path__ + "img/approved-lock.cee3e03.svg";